// Top level pages
export * from './page-home/page-home.component';
export * from './page-login/page-login.component';
export * from './page-forgot-password/page-forgot-password.component';
export * from './page-register/page-register.component';
export * from './page-profile/page-profile.component';
export * from './page-about-history/page-about-history.component';
export * from './page-about-staff/page-about-staff.component';
export * from './page-about-terms/page-about-terms.component';
export * from './page-change-password/page-change-password.component';